import { Checkbox, ICheckboxProps, Row } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ReactNode } from 'react';

import './CheckItem.scss';

export interface ICheckItemProps extends ICheckboxProps {
  children: ReactNode;
}

function CheckItem(props: ICheckItemProps) {
  const { children, className, ...checkboxProps } = props;

  const classes = classNames('check-item', className);

  return (
    <Row className={classes}>
      <Checkbox {...checkboxProps} />
      {children}
    </Row>
  );
}

export default CheckItem;
